<template>
  <div class="w-100p position-relative mt-3">
    <div class="error " v-if="errorMsg !== ''">{{ errorMsg }}</div>
    <div class="position-absolute" style="right: 60px; top: 15px; z-index: 1001" v-if="isLoading"><img :alt="$t('loading')" :src="loadingUrl"> {{ $t('loading') }} ...</div>

    <template v-if="isStationsLoaded">

      <form action="?" id="koTab">
        <div class="d-flex justify-content-center">
          <label class="w75 tr fl" for="selectStation">{{ $t('ko.station') }}:</label>

          <select class="w300 fl" id="selectStation" v-model="selectedStation">
            <option v-for="station in stationsBySelectedPollutant" :value="station.station_id">{{ station.station_name }}</option>
          </select>
          <button v-if="showChart" type="button" class="btn" @click="emitLocation"><i class="icon-location2"></i></button>

        </div>
        <div class="clearfix"></div>
      </form>

      <template v-if="selectedStation !== null && showChart">
        <KoChartSub key="subChart" :selected-pollutant-id="selectedPollutant" :station-id-for-chart="this.selectedStation" chart-type="sub"></KoChartSub>
      </template>



    </template>
    <template v-else>
      <div class="text-center pt-3"><img :alt="$t('loading')" :src="loadingUrl"> Načítavam údaje...</div>
    </template>


    <div class="clearfix"></div>
  </div>
</template>

<script>

import Axios from "axios";
import SHMUconf from "../shmu_conf";
import shmuMixin from "../mixin";
import KoChartSub from "./KoChart";

export default {
  components: {
    KoChartSub,
  },
  name: 'KoPollutantsSub',
  props: [
    'selectedPollutant',
    'selectedStationFromMap'
  ],
  mixins: [
    shmuMixin,
  ],
  data() {
    return {
      errorMsg: '',
      isLoading: false,
      isStationsLoaded: false,
      listOfStations: [],
      baseData: null,
      selectedStation: null,
      loadingUrl: SHMUconf.SITE_BASE_URL + 'img/loader.gif',
    }
  },
  watch: {
    selectedStationFromMap(v) {
      this.selectedStation = v;
    },
  },


  mounted() {
    this.loadStations();

  },
  computed: {
    stationsBySelectedPollutant() {
      const sp = this.selectedPollutant;
      let stations = this.listOfStations.filter(item => item.pollutants.find(pol_item => pol_item.pollutant_id === sp))

      return stations.sort((a,b) => a.station_name.localeCompare(b.station_name));

    },
    showChart() {
      const sp = this.selectedPollutant;
      const ss = this.selectedStation;
      const self = this;
      let stations_with_selected_pollutant = this.listOfStations.filter(item => item.pollutants.find(pol_item => pol_item.pollutant_id === sp))
      let found = stations_with_selected_pollutant.find(station => station.station_id === ss);
      return !!found;
    }

  },
  methods: {
    loadStations: function() {
      const self = this;

      self.isStationsLoaded = false;
      self.isLoading = true;
      self.errorMsg = '';
      Axios.get(SHMUconf.API_BASE_URL + 'airquality/getstations', {
        crossDomain: true,
        cache: false,
      })
          .then((response) => {
            if (!response.data.error) {
              self.listOfStations = response.data;
              self.isStationsLoaded = true;
            } else {
              self.errorMsg = 'Nepodarilo sa načítať údaje';
            }
            self.isLoading = false;

          }).catch((error) => {
        self.isLoading = false;
        self.errorMsg = 'Nepodarilo sa nadviazať spojenie so serverom SHMÚ';
      });

    },
    emitLocation() {
      let found = this.listOfStations.find(item => item.station_id === this.selectedStation);
      if (found) {
        this.$emit('locateStation', found);
      }
    }


  },



}
</script>


<style lang="scss">

</style>
